import { Tabs } from "antd";
import useProveedor from "../../hooks/useProveedor";
import CuitMailForm from "../cuit-mail-form/cuit-mail-form.component";
import OrdenesDePago from "../ordenes/ordenes-pago.component";
import Proveedor from "../proveedor/proveedor.component";
import OrdenesDePagoSiniestro from "../ordenes-siniestro/ordenes-pago-siniestro.component";

const OrdenesDePagoContaner = () => {
    // CUIT:27-34566147-1
    // MAIL:nba@copanseguros.com.ar

    const { cuit, cuitAutorizado } = useProveedor();

    return (
        <>
            <CuitMailForm />

            {cuit && (
                <Tabs>
                    <Tabs.TabPane tab='Ordenes de pago' key='item-1'>
                        <OrdenesDePago />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab='Datos proveedor' key='item-2'>
                        <Proveedor />
                    </Tabs.TabPane>
					{cuitAutorizado && <Tabs.TabPane tab='Consulta de órdenes de pago por Nro siniestro' key='item-3'>
                        <OrdenesDePagoSiniestro />
                    </Tabs.TabPane> }
                </Tabs>
            )}
        </>
    );
};

export default OrdenesDePagoContaner;
